import { Label, Link } from '@tiendanube/components';
import { EyeOffIcon } from '@tiendanube/icons';
import { ImageItemStratus, Stack } from 'commons/components';
import { Variant } from 'domains/Catalog/Products/pages/components/Variants/types';
import useTranslationCatalog from 'domains/Catalog/useTranslationCatalog';
import { VariantListItemInterface } from '../../../../../CardVariants';

export interface VisibleVariantInfoDesktopProps {
  variant: VariantListItemInterface;
  index: number;
  onClickImage: (index: number) => void;
  onClickVariant: (index: number) => void;
  onChange: (i: number, v: Partial<Variant>) => void;
}

function VisibleVariantInfoDesktop({
  variant: { id: variantId, name, imageUrl, visible },
  index,
  onClickImage,
  onClickVariant,
  onChange,
}: VisibleVariantInfoDesktopProps) {
  const t = useTranslationCatalog();
  const handleShowVariant = () => onChange(index, { visible: true });
  return (
    <ImageItemStratus
      title={name}
      id={variantId}
      imageUrl={imageUrl}
      onClickImage={() => onClickImage(index)}
      onClickTitle={() => onClickVariant(index)}
    >
      {!visible && (
        <Stack column align="flex-start" spacing="extra-tight">
          <Label
            id={variantId}
            label={`${t('products.productHiddenAndWithoutStock.hidden')}`}
            appearance="warning"
            icon={EyeOffIcon}
          />
          <Link appearance="primary" onClick={handleShowVariant}>
            {t('products.detail.showVariant')}
          </Link>
        </Stack>
      )}
    </ImageItemStratus>
  );
}

export default VisibleVariantInfoDesktop;
